// utils/cache.js 
const CACHE_PREFIX = 'APP_CACHE_'

class CacheManager {
  /**
   * @param {string} type - 存储类型（local/localStorage | session/sessionStorage）
   */
  constructor(type = 'local') {
    this.storage  = type.includes('local')  ? localStorage : sessionStorage
  }

  /**
   * 设置缓存
   * @param {string} key - 缓存键名
   * @param {any} value - 缓存值
   * @param {number} expires - 有效期（单位：秒）
   */
  set(key, value, expires = 3600) {
    try {
      const data = {
        value,
        expires: Date.now()  + expires * 1000
      }
      this.storage.setItem(`${CACHE_PREFIX}${key}`,  JSON.stringify(data)) 
    } catch (error) {
      console.error(' 缓存设置失败:', error)
    }
  }

  /**
   * 获取缓存
   * @param {string} key - 缓存键名
   * @returns {any|null} 缓存值或null
   */
  get(key) {
    try {
      const cachedData = JSON.parse( 
        this.storage.getItem(`${CACHE_PREFIX}${key}`) 
      )
      if (!cachedData) return null

      if (Date.now()  > cachedData.expires)  {
        this.remove(key) 
        return null
      }
      return cachedData.value 
    } catch (error) {
      console.error(' 缓存读取失败:', error)
      return null
    }
  }

  /**
   * 删除缓存
   * @param {string} key - 缓存键名
   */
  remove(key) {
    this.storage.removeItem(`${CACHE_PREFIX}${key}`) 
  }

  /**
   * 清空所有带前缀的缓存
   */
  clear() {
    Object.keys(this.storage) 
      .filter(key => key.startsWith(CACHE_PREFIX)) 
      .forEach(key => this.storage.removeItem(key)) 
  }
}

// 创建默认实例（推荐挂载到Vue原型）
const cache = new CacheManager('local')

export default cache